import { ComponentStyleConfig } from '@chakra-ui/react';
import { StyleFunctionProps } from '@chakra-ui/theme-tools';

export const colorSchemeMap = {
  neutral: {
    _light: {
      bg: 'silver.light',
      color: 'grey.base'
    },
    _dark: {
      bg: 'grey.base',
      color: 'silver.light'
    }
  },
  warning: {
    _light: {
      bg: 'gold.lightest',
      color: 'orange.darkest'
    },
    _dark: {
      bg: 'orange.darkest',
      color: 'gold.lightest'
    }
  },
  error: {
    _light: {
      bg: 'red.lightest',
      color: 'red.darker'
    },
    _dark: {
      bg: 'red.darker',
      color: 'red.lightest'
    }
  },
  success: {
    _light: {
      bg: 'green.lightest',
      color: 'green.darkest'
    },
    _dark: {
      bg: 'green.darkest',
      color: 'green.lightest'
    }
  },
  info: {
    _light: {
      bg: 'purple.lightest',
      color: 'purple.darkest'
    },
    _dark: {
      bg: 'purple.darkest',
      color: 'purple.lightest'
    }
  }
};

const StatusBadgeTheme: ComponentStyleConfig = {
  baseStyle: (props: StyleFunctionProps) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    borderRadius: '4px',
    padding: '2px 4px',
    textTransform: 'capitalize',
    fontSize: 'sm',
    fontWeight: 'medium',
    height: '18px',
    width: 'fit-content',
    ...colorSchemeMap[props.colorScheme]
  })
};

export default StatusBadgeTheme;
